import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-para',
  imports: [CommonModule],
  templateUrl: './para.component.html',
  styleUrl: './para.component.scss'
})
export class ParaComponent {

  @Input() heading!: string ;
  @Input() para: string[] | string = [];
  @Input() isSinglePara!: boolean |undefined;
  @Input() paraLink!: string[] |undefined;
  @Input() headerSize!: string

  head1: string = '';
  parasString1: string = '';
  paras1!: string[];


  ngOnInit() {
    // console.log(this.isSinglePara);
    // console.log(this.heading);
    // console.log(this.para);
    this.head1 = "";


    if (this.para && this.isSinglePara) {
      this.parasString1 = Array.isArray(this.para) ? this.para.join(' ') : this.para;
    } else {
      this.paras1 = Array.isArray(this.para) ? [this.para.join('<br>')] : [this.para];
    }
  }
  constructor() { }
  toLines(para: any): string[] {
    if (para === null) return []
    if (Array.isArray(para)) return para.map(v => String(v))
    return [String(para)]
  }


  segments(line: string): Array<{ text: string, bold: boolean }> {
    const out: Array<{ text: string, bold: boolean }> = [];
    if (!line) return out;
    const re = /\*\*(.+?)\*\*/g;
    let last = 0, m: RegExpExecArray | null;
    while ((m = re.exec(line)) !== null) {
      const start = m.index, end = re.lastIndex;
      if (start > last) out.push({ text: line.slice(last, start), bold: false });
      out.push({ text: m[1], bold: true })
      last = end
    }
    if (last < line.length) out.push({ text: line.slice(last), bold: false })
    if (out.length === 0) out.push({ text: line, bold: false });
    return out;
  }

  hasLink(index: number): boolean {
    return !!(this.paraLink && this.paraLink[index] && this.paraLink[index].trim() !== '');
  }

  getLink(index: number): string {
    return this.paraLink?.[index] || '';
  }


  // processText(text: string): string {
  //  // console.log("Text ",text)
  //   return text?.replace(/\*([^*]+)\*/g, '<strong>$1</strong>');
  // }

  processText(text: string): string {
    const formats = [
      { regex: /\*([^*]+)\*/g, type: 'bold' },
      { regex: /\{\{([^}]+)\}\}/, type: 'red' }
    ];

    formats.forEach(({ regex, type }) => {
      text = text?.replace(regex, function (_, match) {
        switch (type) {
          case 'bold':
            return '<strong>' + match + '</strong>';
          case 'red':
            return '<span class="red-text">' + match + '</span>';
          default:
            return match;
        }
      });
    });
    return text;
  }



}
